<template>
  <div style="text-align: left; font-size: 0.24rem">
    <ul class="enable-list-type">
      <li>请正确填写付款人的真实姓名</li>
      <li>如收款资料页面没有附言，转账时的附言栏位请留空白</li>
      <li>如留下备注或附言会造成交易失败，若交易失败，资金会需要至少七个工作天才可以退款</li>
      <li v-if="getSupportAmountText() != ''">该通道人民币存款金额目前只支持{{ getSupportAmountText() }}</li>
      <li style="color: #ff5455">每次入金如以过去旧有收款账号操作入金，其所存入金额将无法追回，敬请留意</li>
      <li v-if="mdMatchPayIDs.includes(payId)" style="color: #ff5455">请于支付完成后回到存款页面上传支付截图，截图必须包含完整的姓名、银行数据（无「*」号）、完整时间、金额。最终请依照页面要求格式提供截图或点击已付款，否则将无法到账</li>
      <li v-if="mdMatchPayIDs.includes(payId)" style="color: #ff5455">扣款后超过20分钟内未到账，请主动联系客服查询，超过30分钟内未联系款项将会延迟到账或退款。</li>
    </ul>
  </div>
</template>
<script>
export default {
  name: 'ChinawayOTCAlert',
  props: ['wayAmounts', 'payId'],
  data() {
    return {
      amounts: this.wayAmounts || [],
      otcIDs: process.env.VUE_APP_OTC_IDS.split(',').map(id => Number(id)),
      mdMatchPayIDs: process.env.VUE_APP_MD_MATCH_PAY_IDS.split(',').map(id => Number(id))
    }
  },
  methods: {
    getSupportAmountText() {
      if (this.otcIDs.includes(this.payId)) {
        return '2000以下,可自我输入金額'
      }

      if (this.amounts.length > 0) {
        return `${this.amounts.join('/ ')}固定金额`
      }

      return ''
      // return '3000以上，可自我输入金额'
    }
  }
}
</script>
